import { useTranslation } from 'react-i18next';
import type { ILawPartProps } from './ILawPartProps';
import { groupsOf } from './lawGroups';

/**
 * «Які структури визначає закон» (прототип v4 lawOrgs): групи за роллю закону щодо структури (у порядку варіантів поля: створює, надає
 * повноваження, …), у кожній — структури з видом; архівні не показуються.
 */
export function LawOrgs({ law, labels, onOpen }: ILawPartProps) {
  const { t } = useTranslation();
  const orgs = law.of('ldorg').filter((r) => r.status !== 'Archived');
  return (
    <section className="law-sec">
      <div className="law-sec__title">{t('recordPage.law.orgs')}</div>
      <div className="law-orgs">
        {groupsOf(orgs, 'role', labels.order('ldorg', 'role')).map((g) => (
          <div key={g.value} className="law-orgs__group">
            <span className="law-orgs__label">{labels.option('ldorg', 'role', g.value)}</span>
            {g.items.map((r) => (
              <button key={r.id} type="button" className="law-orgs__item" onClick={() => onOpen('ldorg', r)}>
                <span className="law-orgs__name">{r.title}</span>
                <span className="law-orgs__kind">{labels.option('ldorg', 'kind', r.values['kind'])}</span>
              </button>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
